import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./index.css";
import Home from "./App";
import DetailingPage from "./consultation";
import PaintRepair from "./PaintRepair";

import PaintlessDentRemoval from "./PaintlessDentRemoval";
import RoutineMaintenance from "./RoutineMaintenance";
import BiroJasa from "./BiroJasa";
import BuyAndSellUsedCar from "./BuyAndSellUsedCar";
import Coatingpage from "./Detailling&coading";
import Information from "./Information";
import Promopage from "./Promo";
import ReviewPage from "./Review";
import Article1 from "./Informasi/Article1";
import Article2 from "./Informasi/Article2";
import Article3 from "./Informasi/Article3";
import Article4 from "./Informasi/Article4";
import Article5 from "./Informasi/Article5";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.css";
import Error404Page from "./notfound";
import WhatsAppButton from "./Component/wa";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/consultation-info" element={<DetailingPage />} />
        <Route path="/detailing&coating-info" element={<Coatingpage />} />
        <Route path="/paint-repair" element={<PaintRepair />} />

        <Route path="/pdr" element={<PaintlessDentRemoval />} />
        <Route path="/routine-maintenance" element={<RoutineMaintenance />} />
        <Route path="/biro-jasa" element={<BiroJasa />} />
        <Route path="/used-car" element={<BuyAndSellUsedCar />} />

        <Route path="/Informasi" element={<Information />} />
        <Route
          path="/Informasi/Hindari-5-Penyebab-Munculnya-Baret-Halus-Pada-Permukaan-Mobil-yang-Jarang-Disadari!"
          element={<Article1 />}
        />
        <Route
          path="/Informasi/Ternyata-Ini-yang-Menyebabkan-Munculnya-Jamur-Pada-Permukaan-Cat-dan-Kaca-Mobil"
          element={<Article2 />}
        />
        <Route
          path="/Informasi/3-Rahasia-Menghilangkan-Baret-Pada-Permukaan-Body-Mobil"
          element={<Article3 />}
        />
        <Route
          path="/Informasi/5-Langkah-Ini-Akan-Membuat-Mesin-Mobil-Kamu-Bersih-dan-Lebih-Awet!"
          element={<Article4 />}
        />
        <Route
          path="/Informasi/6-Rahasia-Merawat-Interior-Mobil-Agar-Tidak-Kusam-dan-Berdebu"
          element={<Article5 />}
        />
        <Route path="/Promo" element={<Promopage />} />
        <Route path="/testimoni" element={<ReviewPage />} />
        <Route path="*" element={<Error404Page />} />
      </Routes>
    </Router>
    <WhatsAppButton />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
